module.exports = __webpack_public_path__ + "static/media/57465186_127719958395236_2192767300677926912_o.28d28154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/57465186_127719958395236_2192767300677926912_o.jpg
// module id = 41
// module chunks = 0